import { combineReducers } from 'redux';

import * as flightsSearchReducer from './Flights/Search';
import * as flightsResultsReducer from './Flights/Results';
import * as hotelsSearchReducer from './Hotels/Search';
import * as hotelsResultsReducer from './Hotels/Results';
import * as shareReducers from './Share';
import passengers from './passengers';
import address from './address';
import info from './info';
import { i18nReducer } from 'react-redux-i18n';
// import logger from 'redux-logger';

const oldReducersInUse = Object.assign(
  flightsSearchReducer,
  flightsResultsReducer,
  hotelsSearchReducer,
  hotelsResultsReducer,
  shareReducers,
  { i18n: i18nReducer }
)

export default combineReducers({
  ...oldReducersInUse,
  passengers,
  address,
  info
})